var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tab-menu'),_c('div',{staticClass:"container"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h1',[_vm._v("Sistema de finanzas")])]),_c('el-col',{attrs:{"span":24}},[_c('img',{staticClass:"img-home",attrs:{"src":require("@/assets/images/home.jpeg")}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }